<template>
  <div id="pass20">
    <v-form ref="sF1Form" v-model="sF1FormValid" lazy-validation>
      <v-row id="pass1F">
        <v-col cols="12">
          <v-card class="ep-rechner-box">
            <v-col cols="12" class="p-0">
              <div class="v-card__title p-0">
                <h2 class="v-card--head--title">
                  {{ selectedLang.AdditionalFlightsTile1 }}
                </h2>
              </div>
            </v-col>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="v-card--msg">
                    <h2 class="ep-rechner-h2" v-if="dataFS.res == 'fs'">
                      {{ selectedLang.AdditionalFlightsTile2 }}
                    </h2>
                    <h2 class="ep-rechner-h2" v-if="dataFS.res == 'ma' && !manRunSs">
                      {{ selectedLang.AdditionalFlightsTile3 }}
                      <br />
                      <br />
                      {{ selectedLang.AdditionalFlightsTile4 }}
                    </h2>
                    <h2 class="ep-rechner-h2" v-if="dataFS.res == 'ma' && manRunSs">
                      {{ selectedLang.AdditionalFlightsTile6 }}
                    </h2>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <h3 class="hghlght" v-if="dataFS.res == 'fs'">
              {{
                dataFS.airline.name +
                " - " +
                flN +
                " " +
                selectedLang.AdditionalFlightsTileOn +
                " " +
                computedDateFormatted
              }}
            </h3>
            <h3 class="hghlght" v-if="dataFS.res == 'ma' && !manRunSs">
              {{
                flN +
                " " +
                selectedLang.AdditionalFlightsTileOn +
                " " +
                computedDateFormatted
              }}
            </h3>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-autocomplete attach v-model="manDepAir" :items="airports" :loading="isLoading"
                    :filter="customFilter" :disabled="pass1F" color="blue-grey lighten-2"
                    :label="selectedLang.AdditionalFlightsTile7" clearable flat item-text="fsidAN" item-value="item"
                    prepend-icon="flight_takeoff" return-object required :rules="[
                      (v) => !!v || selectedLang.AdditionalFlightsTile8 + '',
                    ]">
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME">
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete attach v-model="manArrAir" :items="airports" :loading="isLoading" :disabled="pass1F"
                    :filter="customFilter" color="blue-grey lighten-2" :label="selectedLang.AdditionalFlightsTile9"
                    clearable flat item-text="fsidAN" item-value="item" prepend-icon="flight_land" return-object
                    required :rules="[
                      (v) => !!v || selectedLang.AdditionalFlightsTile10 + '',
                    ]">
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME">
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="divider-topline-res">
                <v-col v-if="selectedCase.valN == 5" cols="12">
                  <v-alert outlined color="info" transition="scale-transition" class="text-center">{{
                    selectedLang.AdditionalFlightsTile77d }}</v-alert>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select attach v-model="selectedCase" :items="cases" :disabled="pass1F"
                    :menu-props="{ top: true, offsetY: true }" item-text="text" return-object
                    prepend-icon="report_problem" :label="selectedLang.AdditionalFlightsTile11" required :rules="[
                      (v) => !!v || selectedLang.AdditionalFlightsTile12 + '',
                    ]"></v-select>
                </v-col>
              </v-row>
              <v-row class="tooltipbox divider-bottomline">
                <v-col cols="12" sm="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                        <v-icon dark> mdi-help </v-icon>
                      </v-btn>
                    </template>
                    <span v-html="selectedLang.AdditionalFlightsTile12a"></span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <template>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-dialog v-model="dateMenuDep" :close-on-content-click="false" :nudge-right="40" :disabled="pass1F"
                      transition="scale-transition" offset-y min-width="290px" max-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field required v-model="computedDateFormattedDepDate"
                          :label="selectedLang.AdditionalFlightsTile13" prepend-icon="event" :rules="[
                            (v) =>
                              !!v || selectedLang.AdditionalFlightsTile14 + '',
                          ]" readonly :disabled="pass1F" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker :min="anMinDate" :max="actMaxDate" :disabled="pass1F" :first-day-of-week="1"
                        locale="de-DE" v-model="plannedArrDate" @input="dateMenuDep = false"></v-date-picker>
                    </v-dialog>
                    <v-dialog attach ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                      :disabled="pass1F" :return-value.sync="time1" transition="scale-transition" offset-y
                      max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field required v-model="time1" :disabled="pass1F"
                          :label="selectedLang.AdditionalFlightsTile16" prepend-icon="access_time" readonly :rules="[
                            (v) =>
                              !!v || selectedLang.AdditionalFlightsTile17 + '',
                          ]" v-on="on"></v-text-field>
                      </template>
                      <v-time-picker v-if="menu1" v-model="time1" :disabled="pass1F" format="24hr" full-width
                        @click:minute="$refs.menu1.save(time1)"></v-time-picker>
                    </v-dialog>
                  </v-col>
                  <v-col v-if="selectedCase.val == 'L'" cols="12" sm="6">
                    <v-dialog attach v-model="dateMenuArr" :close-on-content-click="false" :nudge-right="40"
                      :disabled="pass1F" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field :required="selectedCase.val == 'L'" v-model="computedDateFormattedArrDate"
                          :label="selectedLang.AdditionalFlightsTile20" prepend-icon="event" :disabled="pass1F" :rules="[
                            (v) =>
                              !!v || selectedLang.AdditionalFlightsTile21 + '',
                          ]" readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="actualArrDate" :first-day-of-week="1" locale="de-DE"
                        @input="dateMenuArr = false" :disabled="pass1F" :min="anMinDate"
                        :max="actMaxDate"></v-date-picker>
                    </v-dialog>
                    <v-dialog attach ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                      :disabled="pass1F" :return-value.sync="time2" transition="scale-transition" offset-y
                      max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field :required="selectedCase.val == 'L'" v-model="time2"
                          :label="selectedLang.AdditionalFlightsTile24" :disabled="pass1F" :rules="[
                            (v) =>
                              !!v || selectedLang.AdditionalFlightsTile25 + '',
                          ]" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                      </template>
                      <v-time-picker v-if="menu2" v-model="time2" :disabled="pass1F" format="24hr" full-width
                        @click:minute="$refs.menu2.save(time2)"></v-time-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </template>
              <template v-if="selectedCase.val == 'NB'">
                <v-row>
                  <v-col cols="12">
                    <v-checkbox v-model="timelyAG" :label="formatDBText(selectedLang.AdditionalFlightsTile27, {
                      sAirport4Display: sAirport4Display,
                    })
                      "></v-checkbox>
                  </v-col>
                </v-row>
              </template>
              <template v-if="teaser != ''">
                <v-row>
                  <v-cols cols="12" class="pt-0 pb-2">
                    <p class="text-center mb-0 mt-0" v-html="teaser">
                    </p>
                  </v-cols>
                </v-row>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="!pass1F" id="confirm-data-fl" block @click="confirmF1Flight" :disabled="pass1F"
                class="btn-ep-next-step">
                {{ selectedLang.AdditionalFlightsTile28 }}
              </v-btn>
              <v-btn v-if="pass1F && !noChange" block class="btn-ep-back-to" @click="backToF1()">{{
                selectedLang.AirLineNotificationTile19 }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <template v-if="pass1F && !l4ZB && !passZB">
      <v-card id="l4ZB" class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">
              {{ selectedLang.AdditionalFlightsTile29 }}
            </h2>
          </div>
        </v-col>
        <v-card-text>
          <img :src="imgExSZB" alt="SVG Illustration" class="d-block ep-provider-img" />
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2 pb-7">
                  {{
                    formatDBText(selectedLang.AdditionalFlightsTile30, {
                      sAirport4Display: sAirport4Display,
                    })
                  }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row class="tooltipbox tooltipbox-zubi">
            <v-col cols="12" sm="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                    <v-icon dark> mdi-help </v-icon>
                  </v-btn>
                </template>
                <span v-html="selectedLang.AdditionalFlightsTile30a"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row id="pass22" v-if="!dataFS.airline.isRW6">
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" @click="sZB('y')">{{
                formatDBText(selectedLang.AdditionalFlightsTile31, {
                  sAirport4Display: sAirport4Display,
                })
              }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" @click="sZB('n')">{{ selectedLang.AdditionalFlightsTile32 }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template>
      <v-form id="l4SF" ref="l4SFForm" v-model="l4SFFormValid" lazy-validation>
        <div v-if="l4ZB && !passZB">
          <v-card class="ep-rechner-box">
            <v-col cols="12" class="p-0">
              <div class="v-card__title p-0">
                <h2 class="v-card--head--title">
                  {{ selectedLang.AdditionalFlightsTile33 }}
                </h2>
              </div>
            </v-col>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="v-card--msg">
                    <h2 class="ep-rechner-h2">
                      {{
                        formatDBText(selectedLang.AdditionalFlightsTile34, {
                          sAirport4Display: sAirport4Display,
                        })
                      }}
                    </h2>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="flnZB" :counter="7" :rules="flNZBRules" :disabled="zubiFLS"
                    :label="selectedLang.AdditionalFlightsTile35" :hint="selectedLang.AdditionalFlightsTile36"
                    required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog attach v-model="datepickerflnZB" :close-on-content-click="false"
                    transition="scale-transition" :disabled="zubiFLS" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="computedDateFormattedZB" :label="selectedLang.AdditionalFlightsTile37"
                        persistent-hint :disabled="zubiFLS" prepend-icon="event" readonly v-on="on"
                        required></v-text-field>
                    </template>
                    <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="flDZB" no-title :max="zbMaxDate"
                      :min="zbMinDate" @input="datepickerflnZB = false"></v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col cols="12">
                  <v-btn id="search-fl--zb" block :disabled="zubiFLS || !l4SFFormValid" class="btn-ep-next-step"
                    @click="checkZB">
                    {{ selectedLang.AdditionalFlightsTile38 }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </div>
      </v-form>
      <v-form ref="s4SFForm" v-model="s4SFFormValid" lazy-validation>
        <v-row v-if="zubiFLS">
          <v-col cols="12">
            <v-card class="ep-rechner-box">
              <v-col cols="12" class="p-0">
                <div class="v-card__title p-0">
                  <h2 class="v-card--head--title">
                    {{ selectedLang.AdditionalFlightsTile39 }}
                  </h2>
                </div>
              </v-col>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <div class="v-card--msg">
                      <h2 class="ep-rechner-h2">
                        {{
                          formatDBText(selectedLang.AdditionalFlightsTile40, {
                            sAirport4Display: sAirport4Display,
                          })
                        }}
                      </h2>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <h3 class="hghlght" v-if="dataFSZB.res == 'fs'">
                {{
                  dataFSZB.airline.name +
                  " - " +
                  flnZB +
                  " " +
                  selectedLang.AdditionalFlightsTileOn +
                  " " +
                  computedDateFormattedZB
                }}
              </h3>
              <h3 class="hghlght" v-if="dataFSZB.res == 'ma'">
                {{
                  flnZB +
                  " " +
                  selectedLang.AdditionalFlightsTileOn +
                  " " +
                  computedDateFormattedZB
                }}
              </h3>
              <v-card-text>
                <v-row v-if="dataFSZB.res == 'fs'">
                  <v-col cols="12" sm="6">
                    <v-icon>flight_takeoff</v-icon><br />
                    <h3>
                      {{
                        dataFSZB.airports.airportSName +
                        " (" +
                        dataFSZB.airports.airportSC +
                        ")"
                      }}
                    </h3>
                    <p>{{ fs4DisplayDepZB }}</p>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-icon>flight_land</v-icon><br />
                    <h3>
                      {{
                        dataFSZB.airports.airportTName +
                        " (" +
                        dataFSZB.airports.airportTC +
                        ")"
                      }}
                    </h3>
                    <p>{{ fs4DisplayArrZB }}</p>
                  </v-col>
                </v-row>
                <v-row v-if="dataFSZB.res == 'ma'">
                  <v-col cols="12" sm="6">
                    <v-autocomplete attach v-model="manDepAirZB" :items="airports" :loading="isLoading"
                      :disabled="passZB" :filter="customFilter" color="blue-grey lighten-2"
                      :label="selectedLang.AdditionalFlightsTile41" clearable flat item-text="fsidAN"
                      item-value="data.item" prepend-icon="flight_takeoff" return-object required :rules="[
                        (v) => !!v || selectedLang.AdditionalFlightsTile42 + '',
                      ]">
                      <template v-slot:item="data">
                        <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME">
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <p v-if="dataFS.res == 'fs'">
                      {{
                        dataFS.airports.airportSName +
                        " (" +
                        dataFS.airports.airportSC +
                        ")"
                      }}
                    </p>
                    <p v-if="dataFS.res == 'ma'">
                      {{ manDepAir.airportNAME + " (" + manDepAir.FSID + ")" }}
                    </p>
                  </v-col>
                </v-row>
                <template v-if="isDiffZB">
                  <v-col cols="12">
                    <v-checkbox v-model="isDiffZBC" :label="textDIataZB" :disabled="passZB"></v-checkbox>
                  </v-col>
                </template>
              </v-card-text>
              <v-card-actions>
                <v-btn id="confirm-data-fl--zb" block @click="setZB" :disabled="passZB" class="btn-ep-next-step">
                  {{ selectedLang.AdditionalFlightsTile43 }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-row v-if="noZB && passZB && pass1F && !dataFS.airline.isRW6">
        <v-col cols="12">
          <h2 class="ep-rechner-h2">
            {{
              formatDBText(selectedLang.AdditionalFlightsTile44, {
                sAirport4Display: sAirport4Display,
              })
            }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="passZB && !noChange && pass1F && !dataFS.airline.isRW6">
        <v-col cols="12">
          <v-btn block id="back2FF" class="btn-ep-back-to" @click="backToFeederFlight()">{{
            selectedLang.AirLineNotificationTile19 }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <template v-if="pass1F && !passAN && !l4AN && passZB">
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">
              {{ selectedLang.AdditionalFlightsTile45 }}
            </h2>
          </div>
        </v-col>
        <v-card-text>
          <img :src="imgExSAN" alt="SVG Illustration" class="d-block ep-provider-img" />
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2">
                  {{
                    formatDBText(selectedLang.AdditionalFlightsTile46, {
                      tAirport4Display: tAirport4Display,
                    })
                  }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row id="pass23">
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" :disabled="passAN" @click="sAN('y')">{{
                formatDBText(selectedLang.AdditionalFlightsTile47, {
                  tAirport4Display: tAirport4Display,
                })
              }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn block class="btn-ep-back-to" @click="sAN('n')" id="fl-no-xtra">{{
                selectedLang.AdditionalFlightsTile48 }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <template>
      <v-form id="l4AN" ref="l4AFForm" v-model="l4AFFormValid" lazy-validation>
        <div v-if="l4AN && !passAN">
          <v-card class="ep-rechner-box">
            <v-col cols="12" class="p-0">
              <div class="v-card__title p-0">
                <h2 class="v-card--head--title">
                  {{ selectedLang.AdditionalFlightsTile49 }}
                </h2>
              </div>
            </v-col>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="v-card--msg">
                    <h2 class="ep-rechner-h2">
                      {{
                        formatDBText(selectedLang.AdditionalFlightsTile50, {
                          tAirport4Display: tAirport4Display,
                        })
                      }}
                    </h2>
                  </div>
                </v-col>
                <v-col v-if="dataFS.airline.isRW6" cols="12">
                  <v-alert dense type="warning">
                    {{ formatDBText(selectedLang.AdditionalFlightsTile45a, {
                      "this.dataFS.airline.name":
                        dataFS.airline.name
                    }) }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="flnAN" :counter="7" :rules="flNANRules" :disabled="anschFLS"
                    :label="selectedLang.AdditionalFlightsTile51" :hint="selectedLang.AdditionalFlightsTile52"
                    required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog attach v-model="datepickerflnAN" :close-on-content-click="false"
                    transition="scale-transition" :disabled="anschFLS" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field required v-model="computedDateFormattedAN"
                        :label="selectedLang.AdditionalFlightsTile53" persistent-hint :disabled="anschFLS"
                        prepend-icon="event" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="flDAN" no-title :max="anMaxDate"
                      :min="anMinDate" @input="datepickerflnAN = false"></v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col cols="12">
                  <v-btn id="search-fl--xtra" block :disabled="anschFLS || !l4AFFormValid" class="btn-ep-next-step"
                    @click="checkAN">
                    {{ selectedLang.AdditionalFlightsTile54 }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </div>
      </v-form>
      <v-form ref="s4AFForm" v-model="s4AFFormValid" lazy-validation>
        <div v-if="anschFLS">
          <v-card class="ep-rechner-box">
            <v-col cols="12" class="p-0">
              <div class="v-card__title p-0">
                <h2 class="v-card--head--title">
                  {{ selectedLang.AdditionalFlightsTile55 }}
                </h2>
              </div>
            </v-col>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div class="v-card--msg">
                    <h2 class="ep-rechner-h2">
                      {{
                        formatDBText(selectedLang.AdditionalFlightsTile56, {
                          tAirport4Display: tAirport4Display,
                        })
                      }}
                    </h2>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <h3 class="hghlght" v-if="dataFSAN.res == 'fs'">
              {{
                dataFSAN.airline.name +
                " - " +
                flnAN +
                " " +
                selectedLang.AdditionalFlightsTileOn +
                " " +
                computedDateFormattedAN
              }}
            </h3>
            <h3 class="hghlght" v-if="dataFSAN.res == 'ma'">
              {{
                flnAN +
                " " +
                selectedLang.AdditionalFlightsTileOn +
                " " +
                computedDateFormattedAN
              }}
            </h3>
            <v-card-text>
              <v-row v-if="dataFSAN.res == 'fs'">
                <v-col cols="12" sm="6">
                  <v-icon>flight_takeoff</v-icon><br />
                  <h3>
                    {{
                      dataFSAN.airports.airportSName +
                      " (" +
                      dataFSAN.airports.airportSC +
                      ")"
                    }}
                  </h3>
                  <p>{{ fs4DisplayDepAN }}</p>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-icon>flight_land</v-icon><br />
                  <h3>
                    {{
                      dataFSAN.airports.airportTName +
                      " (" +
                      dataFSAN.airports.airportTC +
                      ")"
                    }}
                  </h3>
                  <p>{{ fs4DisplayArrAN }}</p>
                </v-col>
              </v-row>
              <v-row v-if="dataFSAN.res == 'ma'">
                <v-col cols="12" sm="6">
                  <p v-if="dataFS.res == 'fs'">
                    {{
                      dataFS.airports.airportTName +
                      " (" +
                      dataFS.airports.airportTC +
                      ")"
                    }}
                  </p>
                  <p v-if="dataFS.res == 'ma'">
                    {{ manArrAir.airportNAME + " (" + manArrAir.FSID + ")" }}
                  </p>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete attach v-model="manArrAirAN" :items="airports" :loading="isLoading" :disabled="passAN"
                    :filter="customFilter" color="blue-grey lighten-2" :label="selectedLang.AdditionalFlightsTile57"
                    clearable flat item-text="fsidAN" item-value="item" prepend-icon="flight_land" return-object
                    required :rules="[
                      (v) => !!v || selectedLang.AdditionalFlightsTile58 + '',
                    ]">
                    <template v-slot:item="data">
                      <v-list-item-content v-text="data.item.FSID + ' ' + data.item.airportNAME">
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <template v-if="isDiffAN">
                <v-col cols="12">
                  <v-checkbox v-model="isDiffANC" :label="textDIataAN" :disabled="passAN"></v-checkbox>
                </v-col>
              </template>
            </v-card-text>

            <v-card-actions>
              <v-btn id="confirm-data-fl--xtra" block @click="preCheck20" :disabled="passAN" class="btn-ep-next-step">
                {{ selectedLang.AdditionalFlightsTile59 }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-form>
      <v-row v-if="noAN && passAN && pass1F">
        <v-col cols="12">
          <h2 class="ep-rechner-h2">
            {{
              formatDBText(selectedLang.AdditionalFlightsTile60, {
                tAirport4Display: tAirport4Display,
              })
            }}
          </h2>
        </v-col>
      </v-row>
      <v-row v-if="passAN && !noChange && pass1F">
        <v-col cols="12">
          <v-btn block id="back2CF" class="btn-ep-back-to" @click="backToConnectingFlight()">{{
            selectedLang.AirLineNotificationTile19 }}</v-btn>
        </v-col>
      </v-row>
      <v-form v-if="anschFLS && showTArrivalTile && kiofCla != 'TRF' && !dataEP.futureCancellation" id="sPAA"
        ref="sPAAForm" v-model="sPAAFormValid" lazy-validation>
        <v-row>
          <v-col v-if="dataFSAN.res == 'ma'" cols="12">
            <h2 class="ep-rechner-h2">
              {{ selectedLang.AdditionalFlightsTile61 }}
            </h2>
          </v-col>
          <v-col v-if="dataFSAN.res == 'ma'" cols="12" sm="6">
            <v-dialog attach v-model="dateMenuArrZVP" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px" max-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="computedDateFormattedDepDateZVP" :label="selectedLang.AdditionalFlightsTile62"
                  prepend-icon="event" :disabled="pass20" readonly v-on="on" :rules="[
                    (v) => !!v || selectedLang.AdditionalFlightsTile63 + '',
                  ]" :required="dataFSAN.res == 'ma'"></v-text-field>
              </template>
              <v-date-picker v-model="arrDateZVP" :first-day-of-week="1" locale="de-DE" :min="actMinDateZVA"
                :max="actMaxDateZVA" @input="dateMenuArrZVP = false"></v-date-picker>
            </v-dialog>
          </v-col>
          <v-col v-if="dataFSAN.res == 'ma'" cols="12" sm="6">
            <v-dialog attach ref="menuZVP" v-model="menuZVP" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="timeZVP" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="timeZVP" :label="selectedLang.AdditionalFlightsTile65" prepend-icon="access_time"
                  :disabled="pass20" readonly v-on="on" :rules="[
                    (v) => !!v || selectedLang.AdditionalFlightsTile66 + '',
                  ]" :required="dataFSAN.res == 'ma'"></v-text-field>
              </template>
              <v-time-picker v-if="menuZVP" v-model="timeZVP" format="24hr" full-width
                @click:minute="$refs.menuZVP.save(timeZVP)"></v-time-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12">
            <h2 class="ep-rechner-h2">
              {{ selectedLang.AdditionalFlightsTile67 }}
            </h2>
          </v-col>
          <v-col cols="12" sm="6">
            <v-dialog attach v-model="dateMenuArrZVA" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px" max-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field required v-model="computedDateFormattedArrDateZVA"
                  :label="selectedLang.AdditionalFlightsTile68" prepend-icon="event" :disabled="pass20" readonly
                  v-on="on" :rules="[
                    (v) => !!v || selectedLang.AdditionalFlightsTile69 + '',
                  ]"></v-text-field>
              </template>
              <v-date-picker v-model="arrDateZVA" :first-day-of-week="1" locale="de-DE" @input="dateMenuArrZVA = false"
                :min="actMinDateZVA" :max="actMaxDateZVA"></v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6">
            <v-dialog attach ref="menuZVA" v-model="menuZVA" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="timeZVA" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field required v-model="timeZVA" :label="selectedLang.AdditionalFlightsTile71"
                  prepend-icon="access_time" :disabled="pass20" readonly v-on="on" :rules="[
                    (v) => !!v || selectedLang.AdditionalFlightsTile72 + '',
                  ]"></v-text-field>
              </template>
              <v-time-picker v-if="menuZVA" v-model="timeZVA" format="24hr" full-width
                @click:minute="$refs.menuZVA.save(timeZVA)"></v-time-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12">
            <v-btn id="confirm-data-fl--xtra-time" block @click="runStart21" :disabled="pass20" text
              color="orange darken-1">
              {{ selectedLang.AdditionalFlightsTile72a }}
            </v-btn>
            <v-btn id="confirm-data-fl--xtra-time" block @click="runStart20" :disabled="pass20" text
              color="blue darken-4">
              {{ selectedLang.AdditionalFlightsTile73 }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import axios from "axios";
export default {
  name: "AdditionalFlightsTile",
  data: function () {
    return {
      imgExSZB: "",
      imgExSAN: "",
      sPAAFormValid: false,
      l4AFFormValid: false,
      l4SFFormValid: false,
      sF1FormValid: false,
      s4AFFormValid: false,
      s4SFFormValid: false,
      showTArrivalTile: false,
      selectedCase: "",
      dateMenuDep: false,
      dateMenuArr: false,
      dateMenuArrZVA: false,
      dateMenuArrZVP: false,
      datepickerflnZB: false,
      datepickerflnAN: false,
      menu1: false,
      menu2: false,
      menuZVP: false,
      menuZVA: false,
      flDZB: this.$store.state.zbMaxDate,
      flDAN: this.$store.state.anMinDate,
      mdelay: "",
      plannedArrDate: this.$store.state.depDateF1F,
      actualArrDate: this.$store.state.arrDateF1F,
      arrDateZVP: "",
      arrDateZVA: "",
      time1: this.$store.state.timeDF1F,
      time2: this.$store.state.timeAF1F,
      timeZVP: "",
      timeZVA: "",
      manArrAir: this.$store.state.manArrAir,
      manDepAir: this.$store.state.manDepAir,
      manArrAirAN: "",
      manDepAirAN: "",
      manArrAirZB: "",
      manDepAirZB: "",
      synFludUnR: "",
      timelyAG: false,
      flnAN: "",
      flnZB: "",
      actMinDateZVA: "",
      actMaxDateZVA: "",
      noAN: false,
      noZB: false,
      tempDelayF1F: "",
      textDIataAN: "",
      textDIataZB: "",
      isDiffAN: false,
      isDiffZB: false,
      isDiffZBC: false,
      isDiffANC: false,
      pass1F: false,
      passAN: false,
      passZB: false,
      l4AN: false,
      l4ZB: false,
      inBC: "",
      teaser: "",
      neverArrived: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    ...mapState([
      "anschFLS",
      "manRunSs",
      "selectedDiv",
      "dataFS",
      "dataFSAN",
      "dataFSZB",
      "flN",
      "flD",
      "computedDateFormatted",
      "fs4DisplayDep",
      "fs4DisplayArr",
      "kiofCla",
      "airports",
      "flOODE",
      "zubiFLS",
      "zbMinDate",
      "zbMaxDate",
      "anMinDate",
      "anMaxDate",
      "actMaxDate",
      "pass20",
      "noChange",
      "dataEP",
      "selectedLang",
      "cases",
      "airportMap",
      "firstFlightDelay",
      "wAdditional",
    ]),
    computedDateFormattedAN() {
      return this.formatDate(this.flDAN);
    },
    computedDateFormattedZB() {
      return this.formatDate(this.flDZB);
    },
    computedDateFormattedDepDate() {
      return this.formatDate(this.plannedArrDate);
    },
    computedDateFormattedArrDate() {
      return this.formatDate(this.actualArrDate);
    },
    computedDateFormattedDepDateZVP() {
      return this.formatDate(this.arrDateZVP);
    },
    computedDateFormattedArrDateZVA() {
      return this.formatDate(this.arrDateZVA);
    },
    sAirport4Display() {
      return this.manDepAir.airportIATA;
    },
    tAirport4Display() {
      return this.manArrAir.airportIATA;
    },
    flNANRules() {
      return [
        (v) => !!v || this.selectedLang.AdditionalFlightsTile78 + "",
        (v) =>
          this.flN.toLowerCase() != v.toLowerCase() ||
          this.selectedLang.AdditionalFlightsTile79 + "",
        (v) =>
          /^[0-9]{0,1}[A-Za-z]{1,3}\s*[0-9]{1,5}\s*$/.test(v) ||
          this.selectedLang.AdditionalFlightsTile80 + "",
      ];
    },
    flNZBRules() {
      return [
        (v) => !!v || this.selectedLang.AdditionalFlightsTile81 + "",
        (v) =>
          this.flN.toLowerCase() != v.toLowerCase() ||
          this.selectedLang.AdditionalFlightsTile82 + "",
        (v) =>
          /^[0-9]{0,1}[A-Za-z]{1,3}\s*[0-9]{1,4}\s*$/.test(v) ||
          this.selectedLang.AdditionalFlightsTile83 + "",
      ];
    },
  },
  watch: {
    flDAN() {
      return this.formatDate(this.flDAN);
    },
    flDZB() {
      return this.formatDate(this.flDZB);
    },
    plannedArrDate() {
      this.dateFormattedDD1 = this.formatDate(this.plannedArrDate);
    },
    actualArrDate() {
      this.dateFormattedAD1 = this.formatDate(this.actualArrDate);
    },
    selectedCase() {
      if (this.selectedCase.val != "TRF") {
        if (this.dataFS.distance <= 1500) {
          this.teaser = this.selectedLang.AdditionalFlightsTile28a;
        } else if (this.dataFS.distance > 1500 && this.dataFS.distance <= 3500) {
          this.teaser = this.selectedLang.AdditionalFlightsTile28b;
        } else {
          this.teaser = this.selectedLang.AdditionalFlightsTile28c;
        }
      } else {
        this.teaser = "";
      }
    }
  },
  mounted: async function () {
    const queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    if (window.screen.width >= 769) {
      this.imgExSZB = this.selectedLang.AdditionalFlightsTile29b;
      this.imgExSAN = this.selectedLang.AdditionalFlightsTile46b;
    } else {
      this.imgExSZB = this.selectedLang.AdditionalFlightsTile29a;
      this.imgExSAN = this.selectedLang.AdditionalFlightsTile46a;
    }

    if (urlParams.has("case")) {
      this.inBC = urlParams.get("case");
    }
  },
  methods: {
    ...mapActions([
      "setSelectedDiv",
      "setVar",
      "goToStep",
      "getFlightData",
      "killRun",
      "clearArrays",
      "backToSpecificTile",
    ]),
    backToF1() {
      this.pass1F = false;
      this.setVar({ pos: "dataFSAN", val: {} });
      this.setVar({ pos: "dataFSZB", val: {} });
      this.setVar({ pos: "zubiFLS", val: false });
      this.setVar({ pos: "anschFLS", val: false });
      this.passZB = false;
      this.l4ZB = false;
      this.passAN = false;
      this.l4AN = false;
      this.backToSpecificTile("20");
      this.go2StepL("pass1F", true);
    },
    backToFeederFlight() {
      this.setVar({ pos: "zubiFLS", val: false });
      this.setVar({ pos: "anschFLS", val: false });
      this.passZB = false;
      this.l4ZB = false;
      this.passAN = false;
      this.l4AN = false;
      this.setVar({ pos: "dataFSAN", val: {} });
      this.setVar({ pos: "dataFSZB", val: {} });
      this.backToSpecificTile("20");
      this.go2StepL("back2FF", true);
    },
    backToConnectingFlight() {
      this.setVar({ pos: "anschFLS", val: false });
      this.passAN = false;
      this.l4AN = false;
      this.setVar({ pos: "dataFSAN", val: {} });
      this.backToSpecificTile("20");
      this.go2StepL("back2CF", true);
    },
    mmHacker(val) {
      return parseInt(val.getMonth() + 1) < 10
        ? "0" + parseInt(val.getMonth() + 1)
        : parseInt(val.getMonth() + 1);
    },
    ddHacker(val) {
      return parseInt(val.getDate()) < 10
        ? "0" + parseInt(val.getDate())
        : parseInt(val.getDate());
    },
    parseLocal2ISO(val) {
      let tempDate = new Date(val);
      let mmHack = this.mmHacker(tempDate);
      let ddHack = this.ddHacker(tempDate);
      return tempDate.getFullYear() + "-" + mmHack + "-" + ddHack;
    },
    createDate(date, time) {
      var dd = dayjs(date);
      var t1 = time.split(":");
      dd = dd.hour(t1[0]);
      dd = dd.minute(t1[1]);
      dd = dd.format("YYYY-MM-DDTHH:mm:ss");
      return dd;
    },
    calcDateDiff(date1, date2, time1, time2) {
      var dd = dayjs(date1);
      var ad = dayjs(date2);
      var t1 = time1.split(":");
      var t2 = time2.split(":");
      dd = dd.hour(t1[0]);
      dd = dd.minute(t1[1]);
      ad = ad.hour(t2[0]);
      ad = ad.minute(t2[1]);
      return ad.diff(dd, "minute");
    },
    customFilter(item, queryText) {
      const sAirportName = item.airportNAME.toLowerCase();
      const sAirportIata = item.airportIATA.toLowerCase();
      const searchText = queryText.toLowerCase();
      if (queryText.length <= 3) {
        return sAirportIata.indexOf(searchText) > -1;
      } else {
        return sAirportName.indexOf(searchText) > -1;
      }
    },
    check32() {
      this.killRun({ vm: this });
    },
    switchVal(val) {
      if (val == true || val == "1") {
        return true;
      } else {
        return false;
      }
    },
    go2StepL(val, pos) {
      var elmnt = document.getElementById(val);
      elmnt.scrollIntoView({ pos, behavior: "smooth" });
    },
    setZB() {
      if (this.$refs.s4SFForm.validate()) {
        this.passZB = true;
      }
    },
    sAN(val) {
      if (val == "n") {
        this.noAN = true;
        this.passAN = true;
        this.$gtag.event("2.2 Ohne Anschluss weiter", {
          event_category: "Rechner",
          event_label: "2.2 Ohne Anschluss weiter",
        });
        this.start20();
      } else {
        this.l4AN = true;
        this.$gtag.event("2.3 Mit Anschluss weiter", {
          event_category: "Rechner",
          event_label: "2.3 Mit Anschluss weiter",
        });
      }
      var el = document.querySelector("#pass1F");
      el.scrollTop = el.scrollTop + 250;
    },
    sZB(val) {
      if (val == "n") {
        this.passZB = true;
        this.noZB = true;
        this.$gtag.event("2.4 Ohne Zubringer weiter", {
          event_category: "Rechner",
          event_label: "2.4 Ohne Zubringer weiter",
        });
      } else {
        this.l4ZB = true;
        this.$gtag.event("2.5 Mit Zubringer weiter", {
          event_category: "Rechner",
          event_label: "2.5 Mit Zubringer weiter",
        });
      }
      var el = document.querySelector("#pass1F");
      el.scrollTop = el.scrollTop + 250;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    createNoteDI(val, id) {
      let subStrFLN = this.flN.substring(0, 2);
      let subStrFLN2F = val.substring(0, 2);
      let res = subStrFLN.localeCompare(subStrFLN2F);
      if (res != 0) {
        if (id == "AN") {
          this.isDiffAN = true;
          this.textDIataAN = this.formatDBText(
            this.selectedLang.AdditionalFlightsTile88,
            { "this.flN": this.flN }
          );
        } else {
          this.isDiffZB = true;
          this.textDIataZB = this.formatDBText(
            this.selectedLang.AdditionalFlightsTile89,
            { "this.flN": this.flN }
          );
        }
      }
    },
    parseflN(val) {
      let tempArr = val.toString().split("");
      for (var i = 2; i < tempArr.length; i++) {
        if (parseInt(tempArr[i]) == 0) {
          tempArr[i] = "";
        } else if (parseInt(tempArr[i]) > 0) {
          break;
        }
      }
      let newVal = "";
      tempArr.forEach((element) => {
        newVal += element;
      });
      return newVal;
    },
    parseDate4DisplayT(val) {
      const event = new Date(val);
      const optionst = {
        hour: "2-digit",
        minute: "2-digit",
      };
      return event.toLocaleTimeString("de-DE", optionst);
    },
    parseDate4DisplayD(val) {
      const event = new Date(val);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return event.toLocaleDateString("de-DE", options);
    },
    confirmF1Flight() {
      if (this.$refs.sF1Form.validate()) {
        const flD2C = dayjs(this.flD);
        const t2C = dayjs();
        const h2C = t2C.diff(flD2C, "hour");
        if (h2C < -72 && this.selectedCase.val == "C" || h2C < 0 && (this.selectedCase.val != "TRF" && this.selectedCase.val != "C")) {
          this.setSelectedDiv("32");
          this.setVar({
            pos: "rejectionMessage",
            val: this.selectedLang.AdditionalFlightsTile107,
          });
          this.pass1F = true;
        } else {
          switch (this.selectedCase.val) {
            case "L":
              this.mdelay = this.calcDateDiff(
                this.plannedArrDate,
                this.actualArrDate,
                this.time1,
                this.time2
              );
              this.tempDelayF1F = this.mdelay;
              this.dataFS.mdelay = this.mdelay;
              this.setVar({ target: "dataFS", data: this.dataFS });
              this.setVar({ pos: "kiofCla", val: "L" });
              this.setVar({ pos: "firstFlightDelay", val: this.mdelay });
              this.synFludUnR = this.selectedLang.AdditionalFlightsTile91;
              this.setVar({
                pos: "uploadMeldung",
                val: this.selectedLang.AdditionalFlightsTile92,
              });
              this.setVar({ pos: "flDAN", val: this.flD });
              break;
            case "C":
              if (h2C >= -72 && h2C < 0) {
                this.dataEP.futureCancellation = true;
              } else {
                this.dataEP.futureCancellation = false;
              }
              this.setVar({ pos: "kiofCla", val: "C" });
              this.synFludUnR = this.selectedLang.AdditionalFlightsTile94;
              this.setVar({
                pos: "uploadMeldung",
                val: this.selectedLang.AdditionalFlightsTile95,
              });
              this.setVar({ pos: "flDAN", val: this.flD });
              break;

            case "NB":
              if (!this.timelyAG) {
                this.setSelectedDiv("32");
              } else {
                this.setVar({ pos: "kiofCla", val: "NB" });
                this.synFludUnR = this.selectedLang.AdditionalFlightsTile97;
                this.setVar({
                  pos: "uploadMeldung",
                  val: this.selectedLang.AdditionalFlightsTile98,
                });
                this.setVar({ pos: "flDAN", val: this.flD });
              }
              break;
            case "TRF":
              this.setVar({ pos: "kiofCla", val: "TRF" });
              if (this.selectedCase.valN == 4) {
                this.setVar({
                  pos: "uploadMeldung",
                  val: this.selectedLang.AdditionalFlightsTile98b,
                });
              } else {
                this.setVar({
                  pos: "uploadMeldung",
                  val: this.selectedLang.AdditionalFlightsTile98a,
                });
              }
              this.setVar({ pos: "flDAN", val: this.flD });
              break;
            default:
              break;
          }
          this.setVar({ pos: "synFludUnR", val: this.synFludUnR });
          this.setVar({
            pos: "labelSL",
            val:
              this.selectedLang.AdditionalFlightsTileReason +
              " " +
              this.synFludUnR,
          });
          this.setVar({
            pos: "labelDR",
            val: this.formatDBText(this.selectedLang.AdditionalFlightsTile99, {
              "this.synFludUnR": this.synFludUnR,
            }),
          });
          if (
            this.manDepAir.airportCOUC != "DE" &&
            this.manArrAir.airportCOUC != "DE"
          ) {
            this.setVar({ pos: "flOODE", val: true });
          }

          if (this.dataFS.res == "ma") {
            let timesTemp;
            if (this.kiofCla == "L") {
              timesTemp = {
                actAL: this.createDate(this.actualArrDate, this.time2),
                pubDL: this.createDate(this.flD, "12:00"),
                pubAL: this.createDate(this.plannedArrDate, this.time1),
              };
            } else {
              timesTemp = {
                actAL: this.createDate(this.actualArrDate, "12:00"),
                pubDL: this.createDate(this.flD, "12:00"),
                pubAL: this.createDate(this.plannedArrDate, this.time1),
              };
            }
            this.dataFS.times = timesTemp;
          } else {
            this.dataFS.times.actAL = this.createDate(
              this.actualArrDate,
              this.time2
            );
            this.dataFS.times.pubAL = this.createDate(
              this.plannedArrDate,
              this.time1
            );
          }
          this.setVar({ pos: "dataFS", val: this.dataFS });
          this.passAN = false;
          this.passZB = false;
          this.pass1F = true;
          this.setVar({ pos: "selectedCase", val: this.selectedCase });
          if (this.flOODE) {
            this.setVar({ pos: "flDZB", val: this.flD });
          }

          if (this.dataFS.airline.isRW6) {
            this.sZB("n");
          }
        }
        window.scrollBy({ top: 500, left: 0, behavior: "smooth" });
        var casetext =
          "2.1 Hauptflug mit " + this.selectedCase.text + " bestätigt";
        this.$gtag.event(casetext, {
          event_category: "Rechner",
          event_label: casetext,
        });
      }
    },
    preCheck20() {
      if (this.$refs.s4AFForm.validate()) {
        if (this.kiofCla == "TRF") {
          this.showTArrivalTile = false;
          this.passAN = true;
          this.start20();
        } else {
          this.showTArrivalTile = true;
          this.passAN = true;
        }
      }
    },
    runStart20() {
      if (this.$refs.sPAAForm.validate()) {
        let t1 =
          this.dataFSAN.res == "ma"
            ? this.timeZVP
            : this.parseDate4DisplayT(this.dataFSAN.arrivalDateLocal);
        let d1 =
          this.dataFSAN.res == "ma"
            ? this.arrDateZVP
            : this.dataFSAN.arrivalDateLocal;
        if (this.dataEP.futureCancellation) {
          this.mdelay = 1440;
        } else {
          this.mdelay = this.calcDateDiff(d1, this.arrDateZVA, t1, this.timeZVA);
          console.log(d1);
          console.log(this.arrDateZVA);
          console.log(this.timeZVA);
          console.log(this.mdelay);
        }
        this.start20();
      }
    },
    runStart21() {
      this.mdelay = 1440;
      this.neverArrived = true;
      this.start20();
    },
    start20() {
      var go4ward = false;
      var resText = "";
      var airIsEu = this.dataFS.airline.isEUAirline;

      let hfStartAirportFSID =
        this.manDepAir == ""
          ? this.dataFS.airports.airportSC
          : this.manDepAir.airportIATA;

      let hfTargetAirportFSID =
        this.manArrAir == ""
          ? this.dataFS.airports.airportTC
          : this.manArrAir.airportIATA;

      if (!this.isDiffZBC && this.isDiffZB) {
        this.clearArrays("dataFSZB");
      }

      if (!this.isDiffANC && this.isDiffAN) {
        this.clearArrays("dataFSAN");
        this.mdelay = this.tempDelayF1F;
        console.log("1369: " + this.mdelay);
      }

      let dataANL = Object.keys(this.dataFSAN).length;
      let dataZBL = Object.keys(this.dataFSZB).length;

      var startAirportCC;
      var targetAirportCC;
      var startAirportIsEU;
      var targetAirportIsEU;

      if (this.mdelay <= 179 && this.kiofCla == "L" && dataANL == 0) {
        go4ward = false;
        resText = this.selectedLang.AdditionalFlightsTile100;
      } else if (this.mdelay <= 179 && dataANL > 0 && this.kiofCla != "TRF") {
        go4ward = false;
        resText = this.selectedLang.AdditionalFlightsTile101;
      } else {
        if (dataANL == 0 && dataZBL == 0) {
          startAirportCC =
            this.manDepAir == ""
              ? this.dataFS.airports.airportSCC
              : this.manDepAir.airportCOUC;
          targetAirportCC =
            this.manArrAir == ""
              ? this.dataFS.airports.airportTCC
              : this.manArrAir.airportCOUC;
          startAirportIsEU =
            this.manDepAir == ""
              ? this.dataFS.airports.SisEUAirport
              : this.switchVal(this.manDepAir.isEU);
          targetAirportIsEU =
            this.manArrAir == ""
              ? this.dataFS.airports.TisEUAirport
              : this.switchVal(this.manArrAir.isEU);
          if (
            startAirportCC == "DE" ||
            (targetAirportCC == "DE" && startAirportIsEU) || (targetAirportCC == "DE" && this.kiofCla == "TRF")
          ) {
            go4ward = true;
          } else if (targetAirportCC == "DE" && airIsEu) {
            go4ward = true;
          }
        } else if (dataANL > 0 && dataZBL == 0) {
          this.setVar({ pos: "wAdditional", val: true });
          let anStartAirportFSID = this.manArrAir.airportIATA;
          startAirportCC =
            this.manDepAir == ""
              ? this.dataFS.airports.airportSCC
              : this.manDepAir.airportCOUC;
          targetAirportCC =
            this.manArrAirAN == ""
              ? this.dataFSAN.airports.airportTCC
              : this.manArrAirAN.airportCOUC;
          startAirportIsEU =
            this.manDepAir == ""
              ? this.dataFS.airports.SisEUAirport
              : this.switchVal(this.manDepAir.isEU);
          targetAirportIsEU =
            this.manArrAir == ""
              ? this.dataFSAN.airports.TisEUAirport
              : this.switchVal(this.manArrAirAN.isEU);
          if (
            startAirportCC == "DE" ||
            (targetAirportCC == "DE" && startAirportIsEU) || (targetAirportCC == "DE" && this.kiofCla == "TRF")
          ) {
            go4ward = true;
          } else if (targetAirportCC == "DE" && airIsEu) {
            go4ward = true;
          }
          if (this.tempDelayF1F <= 5 && this.kiofCla == "L") {
            go4ward = false;
          }
          if (hfTargetAirportFSID != anStartAirportFSID) {
            go4ward = false;
          }
        } else if (dataANL == 0 && dataZBL > 0) {
          let zbTargetAirportFSID = this.manDepAir.airportIATA;
          startAirportCC =
            this.manDepAirZB == ""
              ? this.dataFSZB.airports.airportSCC
              : this.manDepAirZB.airportCOUC;
          targetAirportCC =
            this.manArrAir == ""
              ? this.dataFS.airports.airportTCC
              : this.manArrAir.airportCOUC;
          startAirportIsEU =
            this.manDepAirZB == ""
              ? this.dataFSZB.airports.SisEUAirport
              : this.switchVal(this.manDepAirZB.isEU);
          targetAirportIsEU =
            this.manArrAir == ""
              ? this.dataFS.airports.TisEUAirport
              : this.switchVal(this.manArrAir.isEU);
          if (
            startAirportCC == "DE" ||
            (targetAirportCC == "DE" && startAirportIsEU) || (targetAirportCC == "DE" && this.kiofCla == "TRF")
          ) {
            go4ward = true;
          } else if (targetAirportCC == "DE" && airIsEu) {
            go4ward = true;
          }
          if (hfStartAirportFSID != zbTargetAirportFSID) {
            go4ward = false;
          }
        } else if (dataANL > 0 && dataZBL > 0) {
          this.setVar({ pos: "wAdditional", val: true });
          let zbTargetAirportFSID = this.manDepAir.airportIATA;
          let anStartAirportFSID = this.manArrAir.airportIATA;
          startAirportCC =
            this.manDepAirZB == ""
              ? this.dataFSZB.airports.airportSCC
              : this.manDepAirZB.airportCOUC;
          targetAirportCC =
            this.manArrAirAN == ""
              ? this.dataFSAN.airports.airportTCC
              : this.manArrAirAN.airportCOUC;
          startAirportIsEU =
            this.manDepAirZB == ""
              ? this.dataFSZB.airports.SisEUAirport
              : this.switchVal(this.manDepAirZB.isEU);
          targetAirportIsEU =
            this.manArrAir == ""
              ? this.dataFS.airports.TisEUAirport
              : this.switchVal(this.manArrAir.isEU);
          if (
            startAirportCC == "DE" ||
            (targetAirportCC == "DE" && startAirportIsEU) || (targetAirportCC == "DE" && this.kiofCla == "TRF")
          ) {
            go4ward = true;
          } else if (targetAirportCC == "DE" && airIsEu) {
            go4ward = true;
          }
          if (this.tempDelayF1F <= 5 && this.kiofCla == "L") {
            go4ward = false;
          }
          if (
            hfStartAirportFSID != zbTargetAirportFSID ||
            hfTargetAirportFSID != anStartAirportFSID
          ) {
            go4ward = false;
          }
        }
      }

      var isAirInso = this.dataFS.airline.isAirInso;
      var insoAirName = this.dataFS.airline.name;

      if (this.kiofCla == "TRF") {
        isAirInso = this.dataFS.airline.origAirInso;
        insoAirName = this.dataFS.airline.origAirName;
      }

      if (isAirInso) {
        go4ward = false;
        resText = this.formatDBText(
          this.selectedLang.AdditionalFlightsTile102,
          { "this.dataFS.airline.name": insoAirName }
        );
      }

      if (go4ward) {
        if (this.kiofCla == "NB") {
          if (this.wAdditional) {
            this.setSelectedDiv("31");
          } else {
            this.setSelectedDiv("35");
          }
        } else if (this.kiofCla == "C") {
          this.setSelectedDiv("33");
        } else if (this.kiofCla == "L") {
          this.setSelectedDiv("34");
        } else if (this.kiofCla == "TRF" || this.kiofCla == "TRFDB") {
          this.setSelectedDiv("37");
        }
        // if (this.selectedCase.valN == 4) {
        //   this.setSelectedDiv("37");
        // } else {
        //   this.setSelectedDiv("24");
        // }
        this.goToStep({ vm: this, val: this.selectedDiv });
        this.$gtag.event("2.6 Alle Flugdaten bestaetigt", {
          event_category: "Rechner",
          event_label: "2.6 Alle Flugdaten bestaetigt",
        });
        this.updateVals();
      } else {
        if (resText == "") {
          if (
            startAirportCC != "DE" &&
            targetAirportCC != "DE" &&
            (startAirportIsEU || targetAirportIsEU)
          ) {
            let tTextAirline =
              this.dataFS.airline.name == null ? "" : this.dataFS.airline.name;
            resText = this.formatDBText(
              this.selectedLang.AdditionalFlightsTile105,
              {
                "this.flN": this.flN,
                "this.dataFS.airline.name": tTextAirline,
              }
            );
          } else if (!startAirportIsEU && (!targetAirportIsEU || !airIsEu)) {
            resText = this.formatDBText(
              this.selectedLang.AdditionalFlightsTile106,
              { "this.flN": this.flN }
            );
          }
          this.$store.state.rejectionMessage = resText;
        } else {
          this.$store.state.rejectionMessage = resText;
        }
        this.setSelectedDiv("32");
      }
      this.setVar({ pos: "progress", val: true });
      this.setVar({ pos: "pass20", val: true });
      this.l4AN = true;
      this.l4ZB = true;
    },
    updateVals() {
      let dataANL = Object.keys(this.dataFSAN).length;
      let dataZBL = Object.keys(this.dataFSZB).length;
      let airports = {
        airportSName: this.manDepAir.fsidAN,
        airportSC: this.manDepAir.airportIATA,
        startAirport: this.manDepAir,
        targetAirport: this.manArrAir,
        airportTName: this.manArrAir.fsidAN,
        airportTC: this.manArrAir.airportIATA,
      };
      this.dataFS.airports = airports;
      this.dataFS.kiofCla = this.kiofCla;
      if (dataANL > 0) {
        if (this.kiofCla == "TRF") {
          this.timeZVA = "12:00";
          this.timeZVP = "12:00";
        }
        let airports = {};
        if (this.dataFSAN.res == "ma") {
          airports = {
            startAirport: this.dataFS.airports.targetAirport,
            targetAirport: {
              airportLAT: this.manArrAirAN.airportLAT,
              airportLON: this.manArrAirAN.airportLON,
              airportIATA: this.manArrAirAN.airportIATA,
              airportCOUC: this.manArrAirAN.airportCOUC,
              airportICAO: this.manArrAirAN.airportICAO,
            },
          };
          this.dataFSAN.kiofCla = this.kiofCla;
          var timesTemp;
          if (this.kiofCla == "L") {
            timesTemp = {
              actAL: this.createDate(this.arrDateZVA, this.timeZVA),
              pubDL: this.createDate(this.flDAN, "12:00"),
              pubAL: this.createDate(this.arrDateZVP, this.timeZVP),
            };
          } else {
            timesTemp = {
              actAL: this.createDate(this.arrDateZVA, "12:00"),
              pubDL: this.createDate(this.flDAN, "12:00"),
              pubAL: this.createDate(this.arrDateZVP, this.timeZVP),
            };
          }
          this.dataFSAN.times = timesTemp;
        } else {
          airports = {
            startAirport: this.dataFS.airports.targetAirport,
            targetAirport: {
              airportLAT: this.dataFSAN.airports.tlatitude,
              airportLON: this.dataFSAN.airports.tlongitude,
              airportIATA: this.dataFSAN.airports.airportTC,
              airportCOUC: this.dataFSAN.airports.airportTCC,
              airportICAO: this.dataFSAN.airports.airportTICAO,
              airportCity: this.dataFSAN.airports.airportTCity,
            },
            airportSName: this.dataFSAN.airports.airportSName,
            airportSC: this.dataFSAN.airports.airportSC,
            airportTName: this.dataFSAN.airports.airportTName,
            airportTC: this.dataFSAN.airports.airportTC,
          };

          if (!this.neverArrived) {
            this.dataFSAN.times.actAL = this.createDate(
              this.arrDateZVA,
              this.timeZVA
            );
            this.dataFSAN.times.pubAL = this.createDate(
              this.arrDateZVP,
              this.timeZVP
            );
          } else {
            this.dataFSAN.times.actAL = dayjs(this.dataFSAN.times.actAL);
            this.dataFSAN.times.pubAL = dayjs(this.dataFSAN.times.pubAL);
            this.dataFSAN.times.actAL = this.dataFSAN.times.actAL.add(3, 'day');
          }

        }
        this.dataFSAN.airports = airports;
        this.dataFSAN.mdelay = this.mdelay;
        this.setVar({ target: "dataFSAN", data: this.dataFSAN });
      }
      if (dataZBL > 0) {
        let airports = {};
        if (this.dataFSZB.res == "ma") {
          airports = {
            startAirport: {
              airportLAT: this.manDepAirZB.airportLAT,
              airportLON: this.manDepAirZB.airportLON,
              airportIATA: this.manDepAirZB.airportIATA,
              airportCOUC: this.manDepAirZB.airportCOUC,
              airportICAO: this.manDepAirZB.airportICAO,
            },
            targetAirport: this.dataFS.airports.startAirport,
          };
          this.dataFSZB.kiofCla = this.kiofCla;
          if (this.kiofCla == "L") {
            this.dataFSZB.mdelay = this.mdelay;
          }
          this.setVar({ target: "dataFSZB", data: this.dataFSZB });
        } else {
          airports = {
            startAirport: {
              airportLAT: this.dataFSZB.airports.slatitude,
              airportLON: this.dataFSZB.airports.slongitude,
              airportIATA: this.dataFSZB.airports.airportSC,
              airportCOUC: this.dataFSZB.airports.airportSCC,
              airportICAO: this.dataFSZB.airports.airportSICAO,
              airportCity: this.dataFSZB.airports.airportSCity,
            },
            targetAirport: this.dataFS.airports.startAirport,
            airportSName: this.dataFSZB.airports.airportSName,
            airportSC: this.dataFSZB.airports.airportSC,
            airportTName: this.dataFSZB.airports.airportTName,
            airportTC: this.dataFSZB.airports.airportTC,
          };
        }
        this.dataFSZB.airports = airports;
      }
      axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/updateVals.php",
          {
            dataFS: this.dataFS,
            dataZB: this.dataFSZB,
            dataAN: this.dataFSAN,
            fstatus: this.kiofCla,
            delay: this.mdelay,
          }
        )
        .then((response) => {
          this.setVar({ pos: "dataEP", val: response.data });
          if (this.dataFS.res == "ma") {
            this.dataFS.flightIDDB = this.dataEP.flightIDDB;
            this.dataFS.distance = this.dataEP.distance;
            this.setVar({ pos: "dataFS", val: this.dataFS });
          }
          if (this.dataFS.kiofCla == "TRF" && response.data.airline != "") {
            this.dataFS.airline = response.data.airline;
            this.setVar({ pos: "dataFS", val: this.dataFS });
          }
          if (response.data.trff) {
            this.setVar({ pos: "af915", val: false });
          } else if (!response.data.trff) {
            this.setVar({ pos: "af915", val: true });
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    async checkAN() {
      if (this.$refs.l4AFForm.validate()) {
        this.flnAN = this.flnAN.toUpperCase().trim();
        this.flnAN = await this.parseflN(this.flnAN);
        this.createNoteDI(this.flnAN, "AN");
        await this.getFlightData({
          flN: this.flnAN,
          flD: this.flDAN,
          target: "dataFSAN",
        });
        this.setVar({ pos: "anschFLS", val: true });
        this.setVar({ pos: "flnAN", val: this.flnAN });
        this.setVar({ pos: "flDAN", val: this.flDAN });
        if (this.dataFSAN.res == "fs") {
          this.fs4DisplayDepAN =
            this.parseDate4DisplayD(this.dataFSAN.times.pubDL) +
            " " +
            this.parseDate4DisplayT(this.dataFSAN.times.pubDL);
          this.fs4DisplayArrAN =
            this.parseDate4DisplayD(this.dataFSAN.times.pubAL) +
            " " +
            this.parseDate4DisplayT(this.dataFSAN.times.pubAL);
          this.arrDateZVP = this.parseLocal2ISO(
            new Date(this.dataFSAN.arrivalDateLocal)
          );
          this.arrDateZVA = this.arrDateZVP;
          this.timeZVP = this.parseDate4DisplayT(
            this.dataFSAN.arrivalDateLocal
          );
        } else {
          this.arrDateZVP = this.parseLocal2ISO(new Date(this.flDAN));
          this.arrDateZVA = this.arrDateZVP;
        }
        let tempDate = new Date(this.arrDateZVA);
        let mmHack = this.mmHacker(tempDate);
        let ddHack = this.ddHacker(tempDate);
        tempDate.setDate(tempDate.getDate() - 1);
        this.actMinDateZVA =
          tempDate.getFullYear() + "-" + mmHack + "-" + ddHack;
        tempDate.setDate(tempDate.getDate() + 7);
        mmHack = this.mmHacker(tempDate);
        ddHack = this.ddHacker(tempDate);
        this.actMaxDateZVA =
          tempDate.getFullYear() + "-" + mmHack + "-" + ddHack;
      }
      window.scrollBy({ top: 250, left: 0, behavior: "smooth" });
    },
    async checkZB() {
      if (this.$refs.l4SFForm.validate()) {
        this.flnZB = this.flnZB.toUpperCase().trim();
        this.flnZB = await this.parseflN(this.flnZB);
        this.createNoteDI(this.flnZB, "ZB");
        await this.getFlightData({
          flN: this.flnZB,
          flD: this.flDZB,
          target: "dataFSZB",
        });
        this.setVar({ pos: "zubiFLS", val: true });
        this.setVar({ pos: "s1FC", val: true });
        this.setVar({ pos: "flnZB", val: this.flnZB });
        this.setVar({ pos: "flDZB", val: this.flDZB });
        if (this.dataFSZB.res == "fs") {
          this.fs4DisplayDepZB =
            this.parseDate4DisplayD(this.dataFSZB.times.pubDL) +
            " " +
            this.parseDate4DisplayT(this.dataFSZB.times.pubDL);
          this.fs4DisplayArrZB =
            this.parseDate4DisplayD(this.dataFSZB.times.pubAL) +
            " " +
            this.parseDate4DisplayT(this.dataFSZB.times.pubAL);
        }
      }
      window.scrollBy({ top: 250, left: 0, behavior: "smooth" });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
